import { Box, Typography } from '@mui/material';
import { SelectedTabType } from '../../types';
import DesktopFilters from '../DesktopFilters';
import MobileFilters from '../MobileFilters';
import { EVENT_OPTIONS } from './config';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  selectedTab: SelectedTabType;
  onSelectTabHandler: (value: SelectedTabType) => void;
  setOpenFiltersDrawer: (value: boolean) => void;
};

export const HeaderFilterBox = ({
  selectedTab,
  onSelectTabHandler,
  setOpenFiltersDrawer,
}: Props) => {
  const isMobile = useResponsive('down', 'md');
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        {EVENT_OPTIONS.map((eventOption) => {
          const isActive = eventOption.title === selectedTab;

          return (
            <Box
              onClick={() => onSelectTabHandler(eventOption.title)}
              key={eventOption.title}
              sx={{ cursor: 'pointer', borderBottom: isActive ? `2px solid #212B36` : 'none' }}
              data-sm={eventOption.title}
            >
              <Typography sx={{ color: '#212B36' }}>{eventOption.title}</Typography>
            </Box>
          );
        })}
      </Box>
      <Box>
        {isMobile ? (
          <MobileFilters
            openFilters={() => {
              setOpenFiltersDrawer(true);
            }}
          />
        ) : (
          <DesktopFilters
            openFilters={() => {
              setOpenFiltersDrawer(true);
            }}
          />
        )}
      </Box>
    </Box>
  );
};
